import React, { useState } from "react";

const ModalForm = ({
  isVisible,
  onSave,
  onClose,
  streamingName,
  pathsConfig,
  initialFormData = {},
  isEditable = true,
}) => {
  // Validar los campos iniciales y evitar entradas no deseadas
  const [formData, setFormData] = useState(() => { 
    const validPaths = pathsConfig.reduce((acc, pathType) => {
      acc[pathType] = initialFormData[pathType] || ""; // Solo incluir los campos válidos
      return acc;
    }, {});
    console.log(validPaths);
    return {
      streamingName: streamingName || "",
      ...validPaths,
    };

  });

  const handleInputChange = (e) => {
    console.log(formData);
    const { id, value } = e.target;
    // Solo actualizar los campos permitidos
    if (id === "streamingName" || pathsConfig.includes(id)) {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };

  const handleSave = () => {
    onSave(formData); // Envía los datos al componente padre
    onClose(); // Cierra el modal
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 text-white rounded-lg shadow-lg w-full max-w-sm p-6">
        <h2 className="text-xl font-bold mb-4 text-center">
          Streaming Configuration
        </h2>

        {/* Streaming Name */}
        <div className="mb-4">
          <label htmlFor="streamingName" className="block text-sm font-bold mb-2">
            Streaming Name
          </label>
          <input
            id="streamingName"
            type="text"
            value={formData.streamingName}
            onChange={handleInputChange}
            readOnly={!isEditable}
            className={`w-full p-2 bg-gray-700 rounded-lg text-white ${
              isEditable ? "border-2 border-blue-500" : "border-gray-500"
            }`}
          />
        </div>

        {/* Campos dinámicos de paths */}
        {pathsConfig.map((pathType) => (
          <div className="mb-4" key={pathType}>
            <label htmlFor={pathType} className="block text-sm font-bold mb-2">
              {pathType.toUpperCase()} Path
            </label>
            <input
              id={pathType}
              type="text"
              value={formData[pathType]}
              onChange={handleInputChange}
              className="w-full p-2 bg-gray-700 rounded-lg text-white border-gray-500"
            />
          </div>
        ))}

        {/* Actions */}
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="w-[90%] bg-gray-700 hover:bg-gray-600 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="w-[90%] bg-blue-600 hover:bg-blue-500 font-bold py-2 px-4 rounded-lg transition duration-300 border border-white text-white text-sm"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalForm;
